export { default } from './RewardCardNew';
